<p-dialog
  [visible]="displayDialog()"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [breakpoints]="{ '960px': '75vw', '641px': '100vw' }"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
>
  <ng-template #header>
    <h1 class="font-bold text-lg">
      <i class="pi pi-exclamation-triangle text-lg mr-3" style="color: yellow"></i>
      Issues Detected - Close to view calculated load cases
    </h1>
  </ng-template>

  <div class="overflow-y-hidden max-h-[60vh] m-2 pr-2">
    @if (errors(); as err) {

      <!-- OTHER ERRORS -->
      @if (err.otherErrors; as other) {
        @if (other.errorId) {
          <p-card class="mb-4">
            <p><span pTooltip="Double-click to copy" (dblclick)="copyId(other.errorId)"><span class="font-bold text-lg">Error ID</span> {{ other.errorId }}</span></p>
          </p-card>
        }

        @if (other.general) {
          <p-card class="mb-2">
            <ng-template pTemplate="header">
              <div class="font-bold text-lg">General Error:</div>
            </ng-template>
            <div>
              <p><strong>Message:</strong> {{ other.general.message }}</p>
            </div>
          </p-card>
        }

        @if (other.loadCases?.length > 0) {
          <div class="mt-2">
            <h3 class="text-lg font-bold mb-1">Load Case Specific Errors:</h3>
            @for (lcError of other.loadCases; track lcError.loadCaseId; let i = $index) {
              <p-card class="mb-2 last:mb-0">
                <ng-template pTemplate="header">
                  <div class="text-md">
                    <span class="font-semibold">Load Case {{ i + 1 }}:</span> {{ lcError.loadCaseName }}
                  </div>
                </ng-template>
                <div class="mb-2">
                  <p><span pTooltip="Double-click to copy" (dblclick)="copyId(lcError.loadCaseId)"><span class="font-bold">Load Case ID:</span> {{ lcError.loadCaseId }}</span></p>
                  <p><strong>Message:</strong> {{ lcError.error.message }}</p>
                </div>
              </p-card>
            }
          </div>
        }
      }

      <!-- VALIDATION ERRORS -->
      @if (err.validationErrors; as validation) {
        @if (validation?.general) {
          <p-card class="mb-4">
            <ng-template pTemplate="header">
              <div class="font-bold text-lg">Validation Issues:</div>
            </ng-template>
            @for (key of objectKeys(validation.general.details); track key) {
              <div>
                <p> {{ validation.general.details[key].join(', ') }}</p>
              </div>
            }
          </p-card>
        }

        @if (validation.loadCases?.length > 0) {
          <div class="mt-2">
            <h3 class="text-lg font-bold mb-1">Load Case Validation Errors:</h3>
            @for (lcError of validation.loadCases; track lcError.loadCaseId; let i = $index) {
              <p-card class="mb-2 last:mb-0">
                <ng-template pTemplate="header">
                  <div class="text-md">
                    <span class="font-semibold">Load Case {{ i + 1 }}:</span> {{ lcError.loadCaseName }}
                  </div>
                </ng-template>
                @for (key of objectKeys(lcError.error.details); track key) {
                  <div>
                    <p> {{ lcError.error.details[key].join(', ') }}</p>
                  </div>
                }
              </p-card>
            }
          </div>
        }
      }
    }
  </div>

  <ng-template pTemplate="footer">
    <p-button
      label="Close"
      icon="pi pi-times"
      (click)="closeDialog()"
      severity="secondary"
      class="w-full sm:w-auto p-button-raised p-button-secondary"
    ></p-button>
  </ng-template>
</p-dialog>
